import ComponentCard from "../../components/common/ComponentCard";
import AboutListComponent from "../../components/about/AboutListComponent";
import React from "react";
import PageMeta from "../../components/common/PageMeta";

const AboutList = () => {
    return (
        <>
            <PageMeta title="Giới thiệu" description="Trang giới thiệu"/>
            <div className="space-y-6">
                <ComponentCard title="">
                    <AboutListComponent />
                </ComponentCard>
            </div>
        </>
    );
};

export default AboutList;